import * as i from 'types';
import styled from 'styled-components';

import { getColor } from 'styles/utils';

export const Text = styled.p<TextProps>`
  font-size: ${({ size }) => size || '16px'};
  font-family: ${({ theme }) => theme.fonts.barlow};
  color: ${({ variant }) => getColor(variant || ['blue', 'dark'])};
  margin: ${({ margin }) => margin || '0'};
  line-height: ${({ lineHeight }) => lineHeight || '21px'};
  text-align: ${({ align }) => align || 'left'};
  font-weight: ${({ weight }) => weight || 400};
`;

type TextProps = {
  size?: string;
  variant?: i.ColorsFromTheme<'white' | 'blue' | 'black' | 'yellow' | 'red'>
  | i.SubcolorFromTheme<'blue', 'dark'> | i.SubcolorFromTheme<'gray', 'dark'>;
  align?: 'left' | 'center' | 'right';
  margin?: string;
  lineHeight?: string;
  weight?: number;
};
